/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const refrigerantType = async (): Promise<any> => {
  const refridgerantType = useJSONStore.getState().refridgerantType;
  const token = useUserStore.getState().userToken;
  const setRefridgerantType = useJSONStore.getState().setRefridgerantType;

  if (refridgerantType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.deviceType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setRefridgerantType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default refrigerantType;
